import type { Config } from '~/locale/config.ts';
import type { GrammarTableDefinition } from '~/src/language/grammarTables.ts';
import type { MorphemeValue } from '~/src/language/morphemes.ts';

export const genders = ['masc', 'fem', 'neutr', 'nb'] as const;
export type Gender = typeof genders[number];

export const gendersWithNumerus = ['masc', 'fem', 'neutr', 'nb', 'mascPl', 'femPl', 'neutrPl', 'nbPl'] as const;

export const availableGenders = (config: Config): Gender[] => {
    return genders.filter((gender) => gender !== 'nb' || config.nouns.nonbinary);
};

export const iconNamesByGender: Record<Gender, string> = {
    masc: 'mars',
    fem: 'venus',
    neutr: 'neuter',
    nb: 'transgender-alt',
};
export const iconUnicodesByGender: Record<Gender, string> = {
    masc: '\uf222',
    fem: '\uf221',
    neutr: '\uf22c',
    nb: '\uf225',
};
export const longIdentifierByGender: Record<Gender, string> = {
    masc: 'masculine',
    fem: 'feminine',
    neutr: 'neuter',
    nb: 'nonbinary',
};

export interface NounConventionGroup {
    name: string;
    conventions: string[];
    description?: string;
}

export interface NounConvention {
    name: string;
    normative: boolean;
    warning?: string;
    description?: string[];
    morphemes: Record<string, MorphemeValue | string>;
    templates: Record<string, NounConventionTemplate>;
}

interface NounConventionTemplate {
    stem?: string;
    suffix: string;
    declension: string;
}

export interface NounClass {
    exampleStems: Record<string, string>;
}

export interface NounClassExample {
    singular: Record<string, string>;
    plural: Record<string, string>;
}

export interface NounDeclension {
    singular?: Record<string, string>;
    plural?: Record<string, string>;
}

export interface NounConventions {
    morphemes: string[];
    examples: string[];
    grammarTables: GrammarTableDefinition[];
    classes: Record<string, NounClass>;
    classExample: NounClassExample;
    declensions: Record<string, NounDeclension>;
    groups: Record<string, NounConventionGroup>;
    conventions: Record<string, NounConvention>;
}
